import { DynamicItem } from './../interfaces/ToolbarItem';
import Vue from "vue";

export const toolbarMenu = Vue.observable({
    dynamicMenu: [] as DynamicItem[],
    routingPath: null as unknown as string,
    routeParams: null as unknown as string,
    routeQuery: null as unknown as string
})